import Image from 'next/image';
import React from 'react';
import { OptimizedImage } from '../../common';

/**
 * Contact Information Component
 * Displays addresses, phone numbers, and emails
 * 
 * @param {Array} addresses - Array of address objects
 * @param {Boolean} isDarkMode - Dark mode state
 * @param {String} className - Additional CSS classes
 */
const ContactInfo = ({ addresses, isDarkMode, className = '' }) => {
    if (!addresses || addresses.length === 0) return null;

    return (
        <div className={`footer-contact ${className}`}>
            {/* All Addresses First */}
            {addresses.filter(address => !address.isHidden).map((address, index) => (
                <div key={`address-${index}`} className="mb-2">
                    <div className="d-flex align-items-start" style={{ 
                        color: '#ffffff', 
                        fontSize: '14px', 
                        gap: '8px' 
                    }}>
                        <svg 
                            className="mt-1 flex-shrink-0" 
                            width="16" 
                            height="16" 
                            viewBox="0 0 24 24" 
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            style={{ color: '#d0d0d0' }}
                        >
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                            <circle cx="12" cy="10" r="3"/>
                        </svg>
                        <span style={{ flex: 1 }}>
                            {address.Address} {address.City} {address.Country}
                        </span>
                    </div>
                </div>
            ))}

            {/* All Phone Numbers */}
            {addresses.filter(address => !address.isHidden && address.PhoneNumber).map((address, index) => (
                <div key={`phone-${index}`} className="mb-2">
                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                        <Image 
                            src="https://images.hirego.co.uk/assets/Icons/Phone.svg" 
                            alt="phone" 
                            width={16} 
                            height={16} 
                            style={{ opacity: 0.8, minWidth: '16px', flexShrink: 0 }}
                        />
                        <a 
                            href={`tel:${address.PhoneNumber}`} 
                            style={{
                                color: '#ffffff',
                                textDecoration: 'none',
                                fontSize: '14px',
                                transition: 'color 0.3s ease',
                                flex: 1
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#f17c21'}
                            onMouseLeave={(e) => e.target.style.color = '#d0d0d0'}
                        >
                            {address.PhoneNumber}
                        </a>
                    </div>
                </div>
            ))}

            {/* All Emails */}
            {addresses.filter(address => !address.isHidden && address.Email).map((address, index) => (
                <div key={`email-${index}`} className="mb-2">
                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                        <OptimizedImage 
                            src="https://images.hirego.co.uk/assets/Icons/icon_email_white.svg" 
                            alt="mail" 
                            width={16} 
                            height={16} 
                            style={{ opacity: 0.8, minWidth: '16px', flexShrink: 0 }}
                            priority={false}
                            loading="lazy"
                            quality={65}
                            sizes="16px"
                        />
                        <a 
                            href={`mailto:${address.Email}`} 
                            style={{
                                color: '#ffffff',
                                textDecoration: 'none',
                                fontSize: '14px',
                                transition: 'color 0.3s ease',
                                flex: 1
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#f17c21'}
                            onMouseLeave={(e) => e.target.style.color = '#d0d0d0'}
                        >
                            {address.Email}
                        </a>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ContactInfo;
